import React, { useEffect } from "react";
import { Form, Button, Row, Col, Alert } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getPatientDetails } from "../actions/patientActions";
import Message from "./Message";
import Loader from "./Loader";
import {
  PATIENT_DETAILS_RESET,
  PATIENT_UPDATE_RESET,
} from "../constants/patientConstants";
import { deletePatient } from "../actions/patientActions";
import { useNavigate } from "react-router-dom";
import { PATIENT_DELETE_RESET } from "../constants/patientConstants";
import { notify } from "./notify";
import { Howl } from "howler";
import { FaMobileAlt, FaRegEdit, FaTrash, FaWhatsapp } from "react-icons/fa";

const PatientDetails = ({
  patientId,
  setEditPatientDetails,
  isPhysician,
  patientVehicle,
  setPatientVehicle,
  currentAge,
}) => {
  const patientDetails = useSelector((state) => state.patientDetails);
  const { noRequest, loading, error, patient } = patientDetails;

  const patientUpdateStore = useSelector((state) => state.patientUpdateStore);
  const {
    loading: loadingUpdate,
    updatedPatient,
    error: updateErr,
  } = patientUpdateStore;

  const visitsOfPatientStore = useSelector(
    (state) => state.visitsOfPatientStore,
  );
  const { patientVisits } = visitsOfPatientStore;

  const patientDeleteStore = useSelector((state) => state.patientDeleteStore);
  const { deletedPatient, error: deleteErr } = patientDeleteStore;

  const clinicDetails = useSelector((state) => state.clinicDetails);
  const { clinic } = clinicDetails;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const removePatient = () => {
    if (patientVisits && patientVisits.length > 0) {
      notify({
        title: "Patient Delete",
        message: (
          <p className="lead">
            Patient already had visit.
            <br /> Kindly, delete visit below firstly.
          </p>
        ),
        type: "danger",
        duration: 4000,
      });
    } else {
      if (window.confirm("are you sure?")) {
        dispatch(deletePatient(patientId));
      }
    }
  };

  useEffect(() => {
    if (!patientVehicle || patientVehicle._id !== patientId) {
      setPatientVehicle();
    }

    if (!patientVehicle && noRequest) {
      dispatch(getPatientDetails(patientId));
    }
    if (patient) {
      setPatientVehicle(patient);
      dispatch({ type: PATIENT_DETAILS_RESET });
    }
    if (updatedPatient) {
      setPatientVehicle(updatedPatient);
      setEditPatientDetails(false);
      dispatch({ type: PATIENT_UPDATE_RESET });
    }
    if (deletedPatient) {
      navigate(
        `/patient-list-screen/${clinic.clinicOwnerId}?clinicId=${clinic._id}`,
      );
      notify({
        title: "Delete Patient Success",
        message: <p className="lead">{deletedPatient}</p>,
        type: "success",
        duration: 3000,
      });
      var sound = new Howl({
        src: `/success.mp3`,
      });
      sound.play();
      dispatch({ type: PATIENT_DELETE_RESET });
    }
    if (deleteErr) {
      notify({
        title: "Delete Patient Error",
        message: <p className="lead">{deleteErr}</p>,
        type: "danger",
        duration: 3000,
      });
    }
  }, [
    patientId,
    noRequest,
    patient,
    dispatch,
    updatedPatient,
    deleteErr,
    deletedPatient,
  ]);

  return (
    <Col className="my-3 col-sm-12">
      {error && (
        <Message
          variant="danger"
          children={`Get Patient Details Err:${error}`}
        />
      )}
      {updateErr && (
        <Message
          variant="danger"
          children={`Update Patient Details Err:${updateErr}`}
        />
      )}
      {loading || loadingUpdate ? (
        <Loader />
      ) : (
        <Form className="mb-5">
          <Alert variant="info" className="mt-1 text-center">
            {currentAge &&
              `Age now is: ${currentAge.years} years, ${currentAge.months} months and ${currentAge.days}
               days`}
          </Alert>

          {patientVehicle?.phones?.length > 0 &&
            patientVehicle.phones.map((p, order = 0) => (
              <Row key={order + 1} className="justify-content-center my-3">
                <FaMobileAlt className="text-2xl text-gray-700" />
                {p.phone}
                <a
                  href={`https://wa.me/+2${p.phone}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaWhatsapp size={30} color="green" />
                </a>
              </Row>
            ))}
          {patientVehicle && (
            <Row className="justify-content-center">
              <Row
                className="ml-3 text-primary my-2"
                dangerouslySetInnerHTML={{
                  __html: `${patientVehicle?.note}`,
                }}
              />
            </Row>
          )}
          <Row className="mb-2 justify-content-center">
            {isPhysician &&
              clinic?.patientTags &&
              patientVehicle?.patientTags?.map((t) => (
                <span
                  className="m-2"
                  key={t._id}
                  style={{
                    padding: "4px 8px",
                    background: "#f0f0f0",
                    borderRadius: "4px",
                  }}
                >
                  #
                  {` ${
                    clinic.patientTags?.find(
                      (ct) => ct._id.toString() === t.tagId.toString(),
                    )?.label
                  } ${t.comment}`}
                </span>
              ))}
          </Row>
          <Row className="d-flex justify-content-around text-center">
            <Col className="m-1">
              <Button
                className="btn btn-danger"
                style={{ float: "left" }}
                onClick={() => removePatient()}
              >
                <FaTrash /> Delete Patient
              </Button>
            </Col>
            <Col className="m-1">
              <Button
                className="btn btn-primary"
                style={{ float: "right" }}
                onClick={() => setEditPatientDetails(true)}
              >
                <FaRegEdit /> Edit Details
              </Button>
            </Col>
          </Row>
        </Form>
      )}
      <hr style={{ backgroundColor: "blue" }} />
    </Col>
  );
};

export default PatientDetails;
